<template>
  <div class="ksm-flex-1 ksm-flex-column" style="background-color:#eee">
    <div class="ksm-flex-1 ksm-flex">
      <div class="ksm-flex-00auto">
        <div class="ksm-medien__icon" v-html="$_getSvg('text.svg')"></div>
      </div>
      <div class="ksm-ursonate_osd-wrapper ksm-flex">
        <DeepzoomView
          v-if="seite"
          @changePage="changeSeite"
          :modusOption="modus.option"
          :seiteIdx="parseInt(localParams.seiteIdx,10)"
          :seiten="seiten"
          key="deep_ursonate_texte"
        ></DeepzoomView>
      </div>
    </div>
    <div class="ksm-flex-00auto ksm-flex" style="height:100px; margin-top:20px">
      <div class="ksm-texte__modus_toolbar">
        <div class="ksm-texte__merz-select">
          <select v-model="localParams.seiteIdx" style="width:auto">
            <option v-for="(s,j) in seiten" :value="j+''" :key="j">{{s.name}}</option>
          </select>
        </div>
      </div>
      <div class="ksm-ursonate__thumbnail--wrapper">
        <div class="ksm-ursonate__thumbnail" v-if="seiten">
          <Thumbnail
            @selectItem="changeSeite"
            :seiten="seiten"
            :seiteIdx="parseInt(localParams.seiteIdx,10)"
            :aligen="'horizontal'"
            :imageHeight="75"
          ></Thumbnail>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from "comps/Thumbnail.vue";
import DeepzoomView from "comps/DeepzoomView.vue";
import * as d3 from "d3";
import MixinUrlparams from "comps/mixins/Urlparams";

export default {
  mixins: [MixinUrlparams],
  components: { Thumbnail, DeepzoomView },
  props: ["themaPlaying", "isConnect1"],
  data() {
    return {
      viewName: "textView",
      noteTranscriptMap: null,
      transcriptMeasureMap: null,
      ready: false,
      localParams: {
        seiteIdx: "0"
      }
    };
  },
  watch: {
    seite: {
      deep: true,
      handler: function(d) {}
    },
    themaPlaying: {
      handler(d) {
        this.gotoSeite();
      },
      tree: true
    },
    isConnect1(d) {
      if (d) {
        this.gotoSeite();
      } else {
        const opt = this.modus.option;
        this.$store.state.eventBus.$emit(
          ["marknote.sidebar", opt.viewKey, opt.key].join("-"),
          []
        );
      }
    }
  },
  mounted() {
    this.gotoSeite();
  },
  computed: {
    stateUrlParams() {
      return this.modus.option.urlparams;
    },
    modus() {
      return this.$store.getters["modus/getModusByIdKey"]({
        modusId: "simple",
        viewKey: "ursonate_texte"
      });
    },

    seite() {
      if (this.seiten) {
        return this.seiten[this.localParams.seiteIdx];
      }
    },
    seiten() {
      const list = this.$store.state.ursonate_texte.merzListe;
      if (list) {
        return list[0].seiten;
      }
    }
  },

  methods: {
    changeSeite(i) {
      this.localParams.seiteIdx = i + "";
    },
    gotoSeite() {
      const d = this.themaPlaying;
      const opt = this.modus.option;
      if (d && d.docID) {
        const seite = this.seiten.find(
          seite => seite.seiteIds.indexOf(d.docID) > -1
        );
        if (seite) {
          this.changeSeite(seite.idx);
          let themen = seite.$_themen;
          if (!themen || themen.length < 1) {
            themen = this.$store.getters["modus/getSeiteDataExtendInfo"](
              seite,
              "themen"
            );
          }

          if (themen && d.class) {
            const t = themen.find(t => t.class === d.class);
            if (t) {
              this.$store.state.eventBus.$emit(
                ["marknote.sidebar", opt.viewKey, opt.key].join("-"),
                t.transcripts
              );
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" >
</style>


// WEBPACK FOOTER //
// TextView.vue?69d5a848